import { Platform, StyleSheet } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';
import { theme as defaultTheme } from '../../../theme';

export const LEAGUE_LABEL = 'League';

export const getLeagueSelectorStyles = (theme: Theme) =>
  StyleSheet.create({
    container: {
      marginHorizontal: 16,
      marginTop: 4,
      marginBottom: 8,
    },
    label: {
      fontSize: 12,
      fontWeight: '600',
      color: theme.gray[600],
      marginBottom: 6,
      textTransform: 'uppercase' as const,
      letterSpacing: 0.5,
    },
    dropdown: {
      backgroundColor: theme.background.card ?? theme.white,
      borderRadius: 12,
      borderWidth: 1.5,
      borderColor: theme.gray[400],
      paddingHorizontal: 14,
      paddingVertical: 12,
      minHeight: 48,
      justifyContent: 'center' as const,
      ...(Platform.OS === 'web' && {
        cursor: 'pointer' as const,
      }),
    },
    /** Chevron to signal dropdown / selection. */
    dropdownChevron: {
      marginLeft: 6,
    },
    /** Match horizontal gap between flag and label in `dropdownItemRow` */
    dropdownTriggerFlagWrap: {
      marginRight: 10,
    },
    /** Web: FlatList inside react-native-element-dropdown Modal must scroll */
    dropdownFlatListWeb: {
      maxHeight: 320,
      ...(Platform.OS === 'web' && {
        overflowY: 'scroll' as never,
        WebkitOverflowScrolling: 'touch' as never,
      }),
    },
    dropdownOverlay: {
      backgroundColor: theme.background.card ?? theme.white,
      borderWidth: 1,
      borderColor: theme.gray[300],
      borderRadius: 12,
      marginTop: 4,
    },
    /** Web: position dropdown below trigger (avoids opening upward) */
    dropdownOverlayWeb: {
      marginTop: 0,
    },
    itemContainer: {
      borderBottomWidth: StyleSheet.hairlineWidth,
      borderBottomColor: theme.gray[200],
    },
    itemText: {
      fontSize: 14,
      color: theme.gray[800],
      paddingVertical: 2,
    },
    placeholderText: {
      fontSize: 14,
      color: theme.gray[500],
    },
    selectedText: {
      fontSize: 14,
      fontWeight: '600',
      color: theme.gray[900],
    },
    /** Align with compact CountryFlag width when no flag */
    dropdownItemFlagSpacer: {
      width: 28,
      height: 19,
    },
    dropdownItemRow: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingVertical: 10,
      paddingHorizontal: 12,
      gap: 10,
    },
    dropdownItemLabelText: {
      flex: 1,
      fontSize: 14,
      color: theme.gray[800],
    },
  });

export const leagueSelectorStyles = getLeagueSelectorStyles(defaultTheme);
